import Button from '../components/common/Button';
import PageHero from '../components/layout/PageHero';

const processSteps = [
  {
    number: '01',
    title: 'Fill the Job Application Form',
    description:
      'After a candidate applies through our website or job portals such as Naukri, Indeed, Glassdoor, Work India, Apna Jobs, or other platforms, we first ask them to review the job details and complete the FactorStreet job application form.',
    purpose:
      'Many candidates apply without reading job details properly, so the application form helps us collect structured information before shortlisting.',
    actions: [
      { label: 'View Current Openings', path: '/jobs' },
      { label: 'Fill Application Form', path: '/apply' },
    ],
  },
  {
    number: '02',
    title: 'Group Interview',
    description:
      'Shortlisted candidates are invited for a group interview round. The email will include meeting details, date, time, and instructions.',
  },
  {
    number: '03',
    title: 'Task Round',
    description:
      'Selected candidates from the group interview may be invited to a paid task round. This round helps us evaluate personality, seriousness, communication, and role-specific technical skills through a form, written task, PPT/document submission, or practical assignment. The task round is incentivised, usually between ₹100–₹1000 per form/task depending on the role and task type. Completion of the task does not guarantee final selection.',
    note: {
      label: 'PAID TASK ROUND',
      text: 'Personality, seriousness & technical skills test. Incentive: ₹100–₹1000 per submitted task/form.',
    },
  },
  {
    number: '04',
    title: 'Final Call / Personal Interview',
    description:
      'Candidates who clear the task round are invited for a final personal interview or discussion before selection.',
  },
];

const candidateInstructions = [
  'Read the job description carefully before applying.',
  'Fill the application form honestly and completely.',
  'Check email regularly for updates.',
  'Submit tasks before the deadline.',
  'Keep documents ready if requested.',
];

function HiringProcess() {
  return (
    <>
      <PageHero
        eyebrow="CAREERS"
        title="Hiring Process"
        description="Our hiring process is designed to help us understand candidates properly before interviews, tasks, and final selection."
      />

      <section className="section hiring-process-page">
        <div className="container">
          <div className="hiring-timeline">
            {processSteps.map((step) => (
              <article className="hiring-step-card" key={step.number}>
                <span className="hiring-step-card__number">{step.number}</span>
                <div>
                  <h2>{step.title}</h2>
                  <p>{step.description}</p>
                  {step.actions ? (
                    <div className="hiring-step-card__actions">
                      {step.actions.map((action, index) => (
                        <Button key={action.path} to={action.path} variant={index === 0 ? 'secondary' : 'primary'}>
                          <span>{action.label}</span>
                        </Button>
                      ))}
                    </div>
                  ) : null}
                  {step.purpose ? <p className="hiring-step-card__purpose">{step.purpose}</p> : null}
                  {step.note ? (
                    <div className="hiring-step-card__note">
                      <strong>{step.note.label}</strong>
                      <span>{step.note.text}</span>
                    </div>
                  ) : null}
                </div>
              </article>
            ))}
          </div>

          <div className="candidate-instructions card">
            <p className="eyebrow">Important Candidate Instructions</p>
            <ul>
              {candidateInstructions.map((instruction) => (
                <li key={instruction}>{instruction}</li>
              ))}
            </ul>
          </div>

          <div className="hiring-cta">
            <div>
              <p className="eyebrow">Ready to apply?</p>
              <h2>Start with the role details, then submit your application.</h2>
            </div>
            <div className="hiring-cta__actions">
              <Button to="/jobs" variant="secondary">
                <span>View Jobs</span>
              </Button>
              <Button to="/apply">
                <span>Apply Now</span>
              </Button>
            </div>
          </div>
        </div>
      </section>
    </>
  );
}

export default HiringProcess;
